// extracted by mini-css-extract-plugin
export default {"carouselContainer":"Carousel_carouselContainer__ae3My"};